import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Styles } from "../styles/popularCourse.js";
import { UNIVERSITIES_ENDPOINT } from "../../../config/api";

const MAX_ITEMS = 9;
const placeholderImage = `${process.env.PUBLIC_URL}/assets/images/course-1.jpg`;

const PopularCourse = ({ courses = [], loading }) => {
  const [universities, setUniversities] = useState([]);
  const [universitiesLoading, setUniversitiesLoading] = useState(false);
  const [universitiesError, setUniversitiesError] = useState("");

  useEffect(() => {
    let ignore = false;

    const fetchUniversities = async () => {
      setUniversitiesLoading(true);
      setUniversitiesError("");
      try {
        const params = new URLSearchParams({
          limit: String(MAX_ITEMS),
        });
        const response = await fetch(
          `${UNIVERSITIES_ENDPOINT}?${params.toString()}`
        );
        if (!response.ok && response.status !== 304) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.message || "Unable to load universities.");
        }
        if (response.status === 304) {
          if (!ignore) {
            setUniversitiesError("");
          }
          return;
        }
        const payload = await response.json();
        if (ignore) {
          return;
        }

        const items = Array.isArray(payload.universities)
          ? payload.universities
          : [];

        const normalized = items
          .slice(0, MAX_ITEMS)
          .map((university) => {
            const id = university._id || university.id || "";
            if (!id) {
              return null;
            }
            return {
              id,
              name: university.universityName || "University",
              image: university.universityImage || "",
            };
          })
          .filter(Boolean);

        setUniversities(normalized);
      } catch (err) {
        if (!ignore) {
          setUniversities([]);
          setUniversitiesError(err.message || "Unable to load universities.");
        }
      } finally {
        if (!ignore) {
          setUniversitiesLoading(false);
        }
      }
    };

    fetchUniversities();

    return () => {
      ignore = true;
    };
  }, []);

  return (
    <Styles>
      <div className="popular-course">
        <h5>Popular University</h5>
        {universitiesLoading ? (
          <p className="loading text-muted">Loading popular universities…</p>
        ) : universitiesError ? (
          <p className="error">{universitiesError}</p>
        ) : universities.length === 0 ? (
          <p className="empty text-muted">No universities to highlight yet.</p>
        ) : (
          <div className="popular-items">
            {universities.map((university) => (
              <div key={university.id} className="item-box d-flex">
                <div className="item-img">
                  <Link
                    to={`${process.env.PUBLIC_URL}/universities/${university.id}`}
                  >
                    <img
                      src={university.image || placeholderImage}
                      alt={university.name}
                    />
                  </Link>
                </div>
                <div className="item-content">
                  <h4 className="university-title">
                    <Link
                      to={`${process.env.PUBLIC_URL}/universities/${university.id}`}
                    >
                      {university.name}
                    </Link>
                  </h4>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="popular-course">
        <h5>Popular Course</h5>
        {loading ? (
          <p className="loading text-muted">Loading popular courses…</p>
        ) : courses.length === 0 ? (
          <p className="empty text-muted">No courses to highlight yet.</p>
        ) : (
          <div className="popular-items">
            {courses.map((course) => (
              <div className="item-box d-flex" key={course.id}>
                {/* <div className="item-img">
                  <Link to={`${process.env.PUBLIC_URL}/courses/${course.id}`}>
                    <img src={placeholderImage} alt={course.programName} />
                  </Link>
                </div> */}
                <div className="item-content">
                  <p className="title">
                    <Link to={`${process.env.PUBLIC_URL}/courses/${course.id}`}>
                      {course.programName}
                    </Link>
                  </p>
                  <p className="provider">{course.universityName}</p>
                  <p className="price">{course.tuitionLabel}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Styles>
  );
};

export default PopularCourse;
